import { render, staticRenderFns } from "./ActorFilter.vue?vue&type=template&id=105f1b6d"
import script from "./ActorFilter.vue?vue&type=script&lang=js"
export * from "./ActorFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports